import React from 'react';
import { Divider, Skeleton, Stack } from '@mui/material';
import { cleanRoomQuestionPermissions } from 'components/CleanRooms/constants';


export const LoadingSkeleton = () => (
  <Stack
    my={2}
    divider={<Divider />}
    spacing={2}
  >
    {Object.values(cleanRoomQuestionPermissions).map((p) => (
      <Stack key={p.name} direction='row' justifyContent='space-between'>
        <Skeleton variant='text' width='60%' height={40} />
        <Skeleton variant='text' width='10%' height={40} />
      </Stack>
    ))}
  </Stack>
);
